<!-- <a class="accessible" href="#main" style="position: absolute; left: -10000px; top: auto; width: 1px; height: 1px; overflow: hidden;">[Skip to Content]</a> -->
<div class="main_wraper" id="layout_wrapper">
  <header class="clearfix">
    <div class="mid_container clearfix">
      <div class="mid_container_inner clearfix">
        <div>
          <a class="accessible" href="#" tabindex="0" role="skip to continue"
            >[Skip to Content]</a
          >
        </div>
        <div
          *ngIf="
            !enableLayoutMenu && isNotStudent && isNotAdmin && enableLayoutPage
          "
        >
          <a
            class="simulation_link"
            href="javascript:void(0)"
            (click)="simulationStatusPath()"
            >[Return to Simulation Status Page]</a
          >
        </div>
        <div class="logo" role="banner" aria-label="secondary navigation">
          <img src="assets/images/logo-aba.png" class="img-responsive" />
        </div>
        <div *ngIf="!enableLayoutMenu" role="navigation">
          <div class="hearer_nav" role="secondary navigation">
            <ul>
              <li>
                <a href="{{ demoLink }}" target="_blank">
                  Click Here To Watch Demo
                </a>
              </li>
              <li>
                <a href="{{ gettingStartedPath }}" target="_blank">
                  Getting Started
                </a>
              </li>
              <li>
                <a [routerLink]="[supportPath]" target="_blank"> Support</a>
              </li>
              <li><a [routerLink]="[changePwdPath]"> Change Password</a></li>
              <li>
                <app-shared-signout></app-shared-signout>
              </li>
            </ul>
          </div>
        </div>
        <div class="header_session">
          <form class="form-horizontal">
            <div class="form-group" *ngIf="!enableLayoutMenu && isNotStudent">
              <label class="control-label col-sm-5 col-xs-5 no_pad" for="email"
                >Select Session:</label
              >
              <div class="col-sm-7 col-xs-7">
                <select
                  class="form-control timezone session_selection"
                  (change)="InsControl($event.target.value)"
                >
                  <option
                    *ngFor="let doc of sessions; let index = index"
                    [value]="doc.id"
                    [selected]="doc.id === selectedSessionId"
                  >
                    {{ doc.name }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="nav2">
      <div class="mid_container">
        <div class="mid_container_inner">
          <div>
            <nav id="primary_nav_wrap">
              <ul class="nav navbar-nav">
                <li><span class="home_page"> BankExec® </span></li>
                <!-- <li class="view_chat" *ngIf="!enableLayoutMenu"><a href="javascript:void(0)" (click)="HomePage()"> BankExec® </a></li> -->
                <ng-content select="[navbar]"> </ng-content>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
<a
  href="javascript:void(0)"
  id="execution-popup1"
  class="btn btn-primary comman_btn remove_margin_top"
  data-toggle="modal"
  data-target="#header_create_newpopup2"
></a>
<div class="user_section clearfix" id="user_layout_detail">
  <div class="mid_container">
    <div class="mid_container_inner">
      <div class="user_name">
        Username: <b>{{ user_email }}</b>
      </div>
      <div class="user_name" *ngIf="enableActionPage && isNotStudent">
        <label>Select Team: </label>
        <select class="team-control team_dd" (change)="setTeam($event)">
          <option
            *ngFor="let team of all_teams; let index = index"
            [selected]="team.id == current_team.id"
            [value]="team.id"
          >
            {{ team.name }}
          </option>
        </select>
      </div>

      <!-- <div *ngIf="enableActionPage && isNotStudent" class="user_name"> Select Team: <b>{{user_email}}</b></div> -->
      <ng-content select="[user_row]"></ng-content>
    </div>
  </div>
</div>
<!-- <flash-messages></flash-messages> -->
<div id="flash_message"></div>
<a id="top_click" onclick="scroll(0,0)"></a>
<button
  id="decision_timeout"
  style="display: none"
  (click)="decision_timeout()"
></button>
<app-execution-popup
  style="display: none"
  id="execution_pop_up"
></app-execution-popup>
